import { useTranslation } from "react-i18next";

export default function IntroText() {
  const { t } = useTranslation("inbraakschade-reparatie");

  return (
    <section className="bg-white py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10 text-center">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-6 md:mb-8">
          {t("intro.h2")}
        </h2>
        <div className="flex flex-col gap-5 md:gap-6">
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("intro.p1")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("intro.p2")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("intro.p3")}
          </p>
          {t("intro.p4") && (
            <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
              {t("intro.p4")}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}